<template>
  <van-popup v-model="siteshow" position="bottom" :overlay="true">
    <div>
      <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
        <div slot="left">取消</div>
        <div slot="right">确定</div>
      </van-nav-bar>
      <mt-picker :slots="slots1"  @change="slots1Change" valueKey="name" ></mt-picker>
      <mt-picker :slots="slots2"  @change="slots2Change" valueKey="name" ></mt-picker>
      <mt-picker :slots="slots3"  @change="slots3Change" valueKey="name" ></mt-picker>
      <mt-picker :slots="slots4"  @change="slots4Change" valueKey="name" ></mt-picker>
    </div>
  </van-popup>
</template>

<script>
import "mint-ui/lib/style.css";
import Vue from "vue";
import { Picker } from "mint-ui";

Vue.component(Picker.name, Picker);
export default {
  name: "bugoods",
  data() {
    return {
      datas: 123,
      siteshow: false,
      slots1: [
        {
          flex: 1,
          values: [{ name: "请选择" }],
          className: "slot1",
          textAlign: "center"
        }
      ],
      slots2: [
        {
          flex: 1,
          values: [],
          className: "slot2",
          textAlign: "left"
        }
      ],
      slots3: [
        {
          flex: 1,
          values: [],
          className: "slot3",
          textAlign: "left"
        }
      ],
      slots4: [
        {
          flex: 1,
          values: [],
          className: "slot4",
          textAlign: "left"
        }
      ],
      province: "",
      city: "",
      town: "",
      county: "",
      gid: this.$route.query.gid
    };
  },
  methods: {
    cityPickershow: function() {
      this.siteshow = !this.siteshow;
    },
    onClickLeft: function() {
      this.siteshow = !this.siteshow;
    },
    onClickRight: function() {
      this.siteshow = !this.siteshow;
      if (
        this.province.name != "请选择" &&
        this.city.name != "请选择" &&
        this.town.name != "请选择"
      ) {
        this.$emit("listenSitedata", [
          this.province,
          this.city,
          this.town,
          this.county
        ]);
      } else {
        this.$toast("请选择完整地址！");
      }
    },
    slots1Change: function(picker, values) {
      console.log(values);
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      if (values[0].name != "请选择") {
        this.slots2[0].values = [{ name: "请选择" }];
        this.slots3[0].values = [];
        this.slots4[0].values = [];
        var id = values[0].id;
        this.$api.get(
          "active/sys/address",
          { id_active: this.gid, area_id: id, level: 2 },
          res => {
            //            $.each(res.data.data,function (index,item) {
            $.each(res.data.data, function(index, item) {
              var arr = { id: item.id, name: item.name };
              _this.slots2[0].values.push(arr);

              //              })
            });
          },
          err => {
            this.$toast("服务器繁忙，请稍后再试");
          }
        );
      } else {
        this.slots2[0].values = [];
        this.slots3[0].values = [];
        this.slots4[0].values = [];
      }
      this.province = values[0];
      this.city = [];
      this.town = [];
      this.county = [];
    },
    slots2Change: function(picker, values) {
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      if (values[0].name != "请选择") {
        this.slots3[0].values = [{ name: "请选择" }];
        this.slots4[0].values = [];
        var id = values[0].id;
        this.$api.get(
          "active/sys/address",
          { id_active: this.gid, area_id: id, level: 3 },
          res => {
            //            $.each(res.data.data,function (index,item) {
            $.each(res.data.data, function(index, item) {
              var arr = { id: item.id, name: item.name };
              _this.slots3[0].values.push(arr);
            });
            //            })
          },
          err => {
            this.$toast("服务器繁忙，请稍后再试");
          }
        );
      } else {
        this.slots3[0].values = [];
        this.slots4[0].values = [];
      }
      this.city = values[0];
      this.town = [];
      this.county = [];
    },
    slots3Change: function(picker, values) {
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      if (values[0].name != "请选择") {
        this.slots4[0].values = [{ name: "请选择" }];
        var id = values[0].id;
        this.$api.get(
          "active/sys/address",
          { id_active: this.gid, area_id: id, level: 4 },
          res => {
            if (res.data.data == false) {
              _this.slots4[0].values = [];
            } else {
              //              $.each(res.data.data,function (index,item) {
              $.each(res.data.data, function(index, item) {
                var arr = { id: item.id, name: item.name };
                _this.slots4[0].values.push(arr);
              });
              //              })
            }
          },
          err => {
            this.$toast("服务器繁忙，请稍后再试");
          }
        );
      } else {
        this.slots4[0].values = [];
      }
      this.town = values[0];
      this.county = [];
    },
    slots4Change: function(picker, values) {
      this.county = values[0];
    },
    getDatas: function() {
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      this.$api.get(
        "active/sys/address",
        { id_active: this.gid, area_id: 0, level: 1 },
        res => {
          $.each(res.data.data, function(index, item) {
            var arr = { name: item.name, id: item.id };
            _this.slots1[0].values.push(arr);
          });
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style scoped>
.picker {
  width: 25%;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/city.vue